import { ApiError } from '@/lib/api';

// Thrown when the media-library permission prompt is declined --
// mirrors use-tier0-state.ts's Tier0CameraPermissionDeniedError
// exactly, folding the whole permission-through-pick sequence into one
// mutationFn so every failure is the mutation's own isError, with
// nothing left outside it that could silently disagree.
export class PhotoLibraryPermissionDeniedError extends Error {}

// Thrown ONLY when the user backs out of the picker -- a genuine,
// intentional "nothing happened", so errorMessage below never
// surfaces it as an error. Do NOT reuse this for any path where the
// picker returned something but reading it failed -- see
// PhotoReadFailedError below, split out for exactly that reason.
export class PhotoPickCancelledError extends Error {}

// Thrown when the picker returned a result but it couldn't actually be
// read (no base64 payload) -- a real failure, unlike a cancel, and
// must produce a real, visible error message.
export class PhotoReadFailedError extends Error {}

// Shared by profile/index.tsx (the main "Save profile" mutation's own
// error) and profile-photos/index.tsx (the three photo mutations
// above) -- extracted here (issue #80's profile-photos split) rather
// than duplicated, since both screens' error surfaces need the exact
// same ApiError/generic-Error fallback behavior.
export function errorMessage(error: Error): string {
  if (error instanceof PhotoLibraryPermissionDeniedError) {
    return 'Allow photo library access in Settings to add a photo.';
  }

  if (error instanceof PhotoPickCancelledError) {
    return '';
  }

  if (error instanceof PhotoReadFailedError) {
    return "Couldn't read that photo. Try a different one.";
  }

  if (error instanceof ApiError) {
    return error.message;
  }

  return error.message || 'Something went wrong. Check your connection and try again.';
}
